import Service from 'react-reservice';

import { IAccountStatistics, IDailyStatistics, IProfitsStatistics } from '@aqx-core/common/api/statistics';

export interface IAssetServiceContext {
  accountStatistic?: IAccountStatistics;
  dailyStatisticLoading?: boolean;
  profitStatisticLoading?: boolean;
  accountStatisticLoading?: boolean;
  dailyStatistics?: IDailyStatistics;
  profitStatistics: IProfitsStatistics[];
  assetVisibility: boolean;
}

const defaultContext: IAssetServiceContext = {
  dailyStatisticLoading: true,
  profitStatisticLoading: true,
  profitStatistics: [],
  accountStatistic: undefined,
  assetVisibility: false
};

class AssetService extends Service<IAssetServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  setDailyStatisticLoading = (loading: boolean) => {
    this.context.dailyStatisticLoading = loading;
  };

  setProfitStatisticLoading = (loading: boolean) => {
    this.context.profitStatisticLoading = loading;
  };

  setAccountStatisticLoading = (loading: boolean) => {
    this.context.accountStatisticLoading = loading;
  };

  setDailyStatistics = (dailyStatistics: IDailyStatistics) => {
    this.context.dailyStatistics = dailyStatistics;
  };

  setProfitStatistics = (profitStatistics: IProfitsStatistics[]) => {
    this.context.profitStatistics = profitStatistics;
  };

  setAccountStatistics = (accountStatistics: IAccountStatistics) => {
    this.context.accountStatistic = accountStatistics;
  };

  resetAccountStatistic = () => {
    this.context.accountStatistic = undefined;
  };

  setAssetVisibility = (nextState: boolean) => {
    this.context.assetVisibility = nextState;
  };
}

export const assetService = new AssetService();
